import { Redirect, Route, Router, Switch, useHistory, useRouteMatch } from "react-router";
import EnterOTP from "../onboarding/enterOTP"
import EnterPAN, { EnterEmailId, EnterMobile } from "../onboarding/enterPAN"
import InvOnboardingLayout from "./InvOnboardingLayout";
import { Box, CardMedia, Grid, Typography, useMediaQuery, useTheme, Paper } from "@mui/material";
import { ApplicationProps } from "../../redux-store/types/api-types";
import { Location } from 'history';
import { OnboardingDetailDialog } from "../onboarding/Router";
import { RIIconOnb, MinorOnbIcon, NRIOnbIcon } from "../../assets/SvgIcons";
const routerList = [
    {
        name: 'Enter PAN Number',
        path: 'enter-pan-number',
        component: EnterPAN,
    },
    {
        name: 'Enter Mobile Number',
        path: 'enter-mobile-number',
        component: EnterMobile,
    },
    {
        name: 'Enter OTP',
        path: 'enter-otp',
        component: EnterOTP,
    },
    {
        name: 'Enter Email Id',
        path: 'enter-email-id',
        component: EnterEmailId,
    },
]

const investorData = [
    {
        "id": "resident_individual",
        "label": "Resident Individuals",
        "subLabel": "(single/Joint)",
        "icon": <RIIconOnb />,
        "requirements": [
            {
                "id": "ri_pan",
                "mainText": "PAN",
                "mutedText": "(KRA - Registered)",
                "additionalText": "All Holders"
            },
            {
                "id": "ri_contact",
                "mainText": "Valid Mobile & Email",
                "mutedText": null
            },
            {
                "id": "ri_bank",
                "mainText": "Bank Account Details",
                "mutedText": "(Account Number, IFSC, Type)"
            },
            {
                "id": "ri_joint",
                "mainText": "For Joint, Bank Pattern Must Match Holding",
                "mutedText": null
            },
            {
                "id": "ri_fatca",
                "mainText": "Fatca Declaration / Additional KYC",
                "mutedText": null
            },
            {
                "id": "ri_nominee",
                "mainText": "Nominee Details + Government Identity",
                "mutedText": null
            },
            {
                "id": "ri_cheque",
                "mainText": "Check Copy Only if Bank Verification Fails",
                "mutedText": null
            }
        ]
    },
    {
        "id": "minor",
        "label": "Minor",
        "subLabel": "(Resident or NRI - via Guardian)",
        "icon": <MinorOnbIcon />,
        "requirements": [
            {
                "id": "m_guardian_pan",
                "mainText": "Guardian's PAN",
                "mutedText": "(KRA - Registered)"
            },
            {
                "id": "m_guardian_contact",
                "mainText": "Guardian's Mobile & Email",
                "mutedText": null
            },
            {
                "id": "m_bank",
                "mainText": "Minor's Bank Account Details",
                "mutedText": "(Account Number, IFSC, Type)"
            },
            {
                "id": "m_cheque",
                "mainText": "Cheque Copy of Minor's Account",
                "mutedText": null
            },
            {
                "id": "m_fatca",
                "mainText": "Fatca Declaration / Additional KYC",
                "mutedText": null
            },
            {
                "id": "m_nominee",
                "mainText": "Nominee Details + Government Identity",
                "mutedText": null
            }
        ]
    },
    {
        "id": "nri",
        "label": "NRIs",
        "subLabel": "(single/Joint)",
        "icon": <NRIOnbIcon />,
        "requirements": [
            {
                "id": "nri_pan",
                "mainText": "PAN",
                "mutedText": "(KRA - Registered)",
                "additionalText": "All Holders"
            },
            {
                "id": "nri_contact",
                "mainText": "Valid Mobile & Email",
                "mutedText": null
            },
            {
                "id": "nri_account",
                "mainText": "NRE/NRO A/C + Cheque Copy",
                "mutedText": null
            },
            {
                "id": "nri_joint",
                "mainText": "For Joint, Bank Pattern Must Match Holding",
                "mutedText": null
            },
            {
                "id": "nri_address",
                "mainText": "Overseas Address Proof",
                "mutedText": "(Utility Bill, DL, etc.)"
            },
            {
                "id": "nri_nominee",
                "mainText": "Nominee Details + Government Identity",
                "mutedText": null
            }
        ]
    }
]

export default function InvOnboardingRoutes({
    location,
}: {
    location: Location<{ application: ApplicationProps; firstHolderName: string }>;
}): JSX.Element {
    const theme = useTheme()
    const history = useHistory();
    const { path } = useRouteMatch();

    const { application, firstHolderName = '' } = location.state || {};
    const { id } = application || {};
    const isSmall = useMediaQuery(theme.breakpoints.down("lg"));


    return (
        <InvOnboardingLayout disableProfileMenu={true}>
            <Box>
                <Box mb="25px" mt={2} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Typography variant='h1' color="text.primary">
                        {id ? 'Add Joint Holder' : 'Onboard Investor'}
                    </Typography>
                    {isSmall && (<OnboardingDetailDialog />)}
                </Box>
                <Box
                    sx={{
                        p: "25px",
                        bgcolor: "background.paper",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        borderRadius: '25px',
                        minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
                        display: "flex",
                        alignItems: "stretch",
                    }}
                >
                    <Grid container sx={{ mt: id ? 1 : 0 }} rowGap={2}>
                        <Grid
                            item
                            xs={12}
                            lg={6}
                            sx={{ alignSelf: 'center', display: { xs: 'none', lg: 'block' } }}
                        >

                            <Grid container spacing={1}>
                                {investorData.map((category) => (
                                    <Grid item xs={12} md={4} key={category.id}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                height: '100%',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            {/* Header Section */}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1.5,
                                                    padding: '5px',
                                                    border: `2px solid ${theme.palette.primary[200]}`,
                                                    borderRadius: '8px',
                                                    minHeight: '80px'
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        fontSize: '32px',
                                                        lineHeight: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {category.icon}
                                                </Box>
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        variant='subtitle_500'
                                                        sx={{
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {category.label}
                                                    </Typography>
                                                    <Typography
                                                        variant='subtitle_500'
                                                        sx={{
                                                            color: 'text.secondary',
                                                            marginTop: '2px',
                                                        }}
                                                    >
                                                        {category.subLabel}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Requirements List */}
                                            <Box
                                                sx={{
                                                    bgcolor: `${theme.palette.primary[200]}`,
                                                    padding: '15px',
                                                    borderRadius: '10px 10px 8px 8px',
                                                    flex: 1,
                                                }}
                                            >
                                                <Box
                                                    component="ul"
                                                    sx={{
                                                        margin: 0,
                                                        paddingLeft: '20px',
                                                        listStyleType: 'disc',
                                                    }}
                                                >
                                                    {category.requirements.map((req, index) => (
                                                        <Box
                                                            component="li"
                                                            key={req.id}
                                                            sx={{
                                                                marginBottom: index < category.requirements.length - 1 ? '12px' : 0,
                                                                color: 'text.primary',
                                                                fontSize: '14px',
                                                                '& ::marker': {
                                                                    color: 'text.primary',
                                                                },
                                                            }}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                variant='overline_400'
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    color: 'text.primary',
                                                                }}
                                                            >
                                                                {req.mainText}{' '}
                                                                {req.mutedText && (
                                                                    <Typography
                                                                        component="span"
                                                                        variant='overline_400'
                                                                        sx={{
                                                                            fontWeight: 600,
                                                                            color: 'text.secondary',
                                                                        }}
                                                                    >
                                                                        {req.mutedText}
                                                                    </Typography>
                                                                )}
                                                            </Typography>
                                                            {req.additionalText && (
                                                                <Typography
                                                                    component="div"
                                                                    variant='overline_400'
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        color: 'text.primary',
                                                                        marginTop: '2px',
                                                                    }}
                                                                >
                                                                    {req.additionalText}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        {/* <Grid
                            item
                            container
                            xs={12}
                            lg={6}
                            sx={{ alignSelf: 'center', display: { xs: 'none', lg: 'flex' } }}
                        >
                            <Grid
                                item xs={3}
                            />
                            <Grid
                                item
                                xs={6}
                            >
                                <CardMedia
                                    component="img"
                                    src="/images/onboard-investor.svg"
                                    alt="Illustration"
                                    width="203px"
                                    height="203px"
                                    sx={{ objectFit: "contain" }}
                                />
                                <Typography
                                    variant='h1'
                                    component="h2"
                                    color="text.primary"
                                    textAlign="center"
                                    py={1}
                                >
                                    {id ? `Please provide joint holder details ${firstHolderName !== 'N/A' ? ` - ${firstHolderName}` : ""}` : "Onboard New Investor"}
                                </Typography>
                                <Typography
                                    variant='subtitle_400'
                                    color="text.secondary"
                                    textAlign="center"
                                >
                                    Offer essential information to facilitate the seamless onboarding of the investor.
                                </Typography>
                            </Grid>
                            <Grid
                                item xs={3}
                            />
                        </Grid> */}
                        {/* <Grid
                            item
                            xs={12}
                            lg={6}
                            sx={{ alignSelf: 'flex-start', display: { xs: 'none', lg: 'flex' } }}
                        >
                            <img src="/images/onboardingDetailDesktop.webp" alt="Onboarding Details" width={"95%"} height={"100%"} />
                        </Grid> */}
                        <Grid
                            item
                            // container
                            xs={12}
                            lg={6}
                            border={`1px solid ${theme.palette.text.secondary}26`}
                            borderRadius="15px"
                            p={{ xs: "15px", sm: "35px" }}
                        >
                            <Grid item xs={12}>
                                <Router history={history}>
                                    <Switch>
                                        <Route
                                            exact
                                            path={path}
                                            render={() => <Redirect to={`${path}/enter-pan-number`} from={location.pathname} />}
                                        />
                                        {routerList.map((item, index) => (
                                            <Route
                                                key={index}
                                                path={`${path}/${item.path}`}
                                                component={item.component}
                                            />
                                        ))}
                                    </Switch>
                                </Router>
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
            </Box>
        </InvOnboardingLayout>
    );
}
